// Kopf der Gespräche: Titel und Reiter Verlauf · Live · Qualität (Qualität nur mit dem Recht „Telefonie verwalten“).
import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useNutzer } from "../auth/AuthContext";
import { T } from "../texte";
import "./gespraeche.css";
import { useLive } from "./liveStore";

export function useDarfQualitaet(): boolean {
  return useNutzer().permissions.includes("telefonie_verwalten");
}

export function useDarfAlle(): boolean {
  return useNutzer().permissions.includes("gespraeche_alle");
}

export function GespraecheKopf({ rechts }: { rechts?: ReactNode }) {
  const darfQualitaet = useDarfQualitaet();
  const live = useLive();
  const zahl = live.gespraeche.length;
  const klasse = ({ isActive }: { isActive: boolean }) => `gesp-reiter__punkt${isActive ? " aktiv" : ""}`;
  return (
    <header className="gesp-kopf">
      <h1 className="gesp-kopf__titel">{T.nav.gespraeche}</h1>
      <nav className="gesp-reiter" aria-label="Gespräche">
        <NavLink to="/gespraeche" end className={klasse}>
          Verlauf
        </NavLink>
        <NavLink to="/gespraeche/live" className={klasse}>
          Live
          {zahl > 0 ? (
            <span className="gesp-zaehler" aria-label={`${zahl} laufend`}>
              {zahl}
            </span>
          ) : null}
        </NavLink>
        {darfQualitaet ? (
          <NavLink to="/gespraeche/qualitaet" className={klasse}>
            Qualität
          </NavLink>
        ) : null}
      </nav>
      {rechts ? <div className="gesp-kopf__rechts">{rechts}</div> : null}
    </header>
  );
}
